import React, { useEffect } from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Head from "next/head";
import { usePathname, useSearchParams, useParams } from "../../shared/hooks/useNavigation";
import Script from "next/script";

import { useStores } from "../../contexts/StoreContext";

function FacebookPixel() {
  const { configStore } = useStores();
  const pathname = usePathname();
  const params = useParams();
  const searchParams = useSearchParams();

  // In Pages Router, router.query contains both path params and query params
  const { config } = configStore;
  const { facebookPixelId, facebookDomainVerification } = config;

  const pageView = () => {
    if (!isEmpty(facebookPixelId)) {
      window.fbq("track", "PageView");
    }
  };

  useEffect(() => {
    pageView();
  }, [pathname, searchParams, params]);

  return (
    <>
      {facebookDomainVerification && (
        <Head>
          <meta
            content={facebookDomainVerification}
            name="facebook-domain-verification"
          />
        </Head>
      )}
      {!isEmpty(facebookPixelId) && (
        <Script id="facebook-pixel">
          {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', ${facebookPixelId});
        fbq('track', 'PageView');
      `}
        </Script>
      )}
    </>
  );
}

export default observer(FacebookPixel);
